import { HorizontalScrollDirection } from '../../domain/direction';
import {
  SCROLL_EDGE_THRESHOLD,
  SCROLL_OPTIONS_STRATEGY
} from './scroll-options-strategy';
import type { ExtendedScrollToOptions } from '@angular/cdk/scrolling';
import type {
  ScrollOptionsStrategy,
  HorizontalScrollPosition } from './scroll-options-strategy';
import type { ScrollableDirective } from './scrollable.directive';

export class RangeScrollOptionsStrategy implements ScrollOptionsStrategy {
  /** Attaches this position strategy to an overlay. */
  scroll(direction: HorizontalScrollDirection,
         scrollable: ScrollableDirective,
         positions: Array<HorizontalScrollPosition>): ExtendedScrollToOptions {

    const scrollOffset = scrollable.measureScrollOffset(direction);

    if (scrollOffset > SCROLL_EDGE_THRESHOLD) {

      let scrollToOptions: ExtendedScrollToOptions = direction === HorizontalScrollDirection.LEFT ?
        { left: 0, behavior: 'smooth' } : { right: 0, behavior: 'smooth' };

      if (scrollOffset >= scrollable.scrollSize) {
        const position = this.getPositionOfIntersection(direction, scrollable, positions);
        const scrollEndPoint = direction === HorizontalScrollDirection.LEFT ?
          position.right - scrollable.scrollSize : position.left;
        scrollToOptions = { left: scrollEndPoint, behavior: 'smooth' };
      }

      scrollable.scrollTo(scrollToOptions);

      return scrollToOptions;
    }
  }

  private getPositionOfIntersection(direction: HorizontalScrollDirection,
                                    scrollable: ScrollableDirective,
                                    positions: Array<HorizontalScrollPosition>): HorizontalScrollPosition {
    const el = scrollable.getElementRef().nativeElement;
    const border = direction === HorizontalScrollDirection.LEFT ? el.scrollLeft : el.scrollLeft + el.clientWidth;
    return positions.find((i: HorizontalScrollPosition): boolean => i.left <= border && i.right >= border);
  }
}

export const SCROLL_OPTIONS_STRATEGY_PROVIDER = {
  provide: SCROLL_OPTIONS_STRATEGY,
  useClass: RangeScrollOptionsStrategy
};
